import { createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { IdNamePair } from '../../@models/index';
import { Injectable, Injector } from '@angular/core';
import { ContactService } from '../../@services/contacts.service';
import { DropdownService } from '../../@services';
import { ENDPOINTS } from 'src/app/@config/endpoints';

@State<IdNamePair[]>({
  name: 'opportunityProductStatus',
  defaults: []
})
@Injectable()
export class OpportunityProductStatusState {

  private static service: DropdownService

  static hasAny() {
    return createSelector([OpportunityProductStatusState], (state: IdNamePair[]) => {
      return state.length > 0;
    });
  }

  static getNameById(id: number) {
    return createSelector([OpportunityProductStatusState], (state: IdNamePair[]) => {
      return state.find((item: IdNamePair) => item.id === id).name;
    });
  }

  constructor(injector: Injector) {
    OpportunityProductStatusState.service = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<OpportunityProductStatusState>) {
    this.service.getDropdownData(ENDPOINTS.getOpportunityProductStatusList()).subscribe(
      (data: IdNamePair[]) => {
        setState(data);
      }
    );
  }

}
